import { Controller } from "@hotwired/stimulus"
import Mustache from 'mustache';
import { useEcharts } from "../../../mixins/useEcharts";
import { buildOptions } from "../../../lib/charts/interest_rates.js";
import { EQUALIZER_STEP_MS, equalizerOptions, equalizerFrame } from "../../../lib/charts/equalizer.js";

export default class extends Controller {
  static values = {
    loading: Boolean,
    theme: { type: Object, default: {} },
    dates: { type: Array, default: [] },
    values: { type: Array, default: [] },
    tooltip: { type: Object, default: {} }
  }
  static targets = ['chart', 'tooltip']

  connect() {
    useEcharts(this);
    this.chart = this.initializeChart(this.chartTarget, this.themeValue, { renderer: 'svg' });
    this.draw();
  }

  // While loading the equalizer stands in for the chart; new values wait for loading to end.
  datesValueChanged() {
    if (!this.loadingValue) this.draw();
  }

  valuesValueChanged() {
    if (!this.loadingValue) this.draw();
  }

  tooltipValueChanged() {
    if (!this.loadingValue) this.draw();
  }

  loadingValueChanged() {
    this.draw();
  }

  draw() {
    if (!this.chart) return;
    clearTimeout(this.equalizerStep);
    if (!this.loadingValue) return this.chart.setOption(this.options, { notMerge: true });
    this.chart.setOption(equalizerOptions(this.options), { notMerge: true });
    if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) this.stepEqualizer();
  }

  // Ends on its own once the chart is disposed.
  stepEqualizer = () => {
    this.equalizerStep = setTimeout(() => {
      if (!this.chart) return;
      this.chart.setOption({ series: equalizerFrame(this.chart.getOption().series) });
      this.stepEqualizer();
    }, EQUALIZER_STEP_MS);
  }

  get tooltip() {
    const tooltipData = this.tooltipValue;
    const tooltipTarget = this.tooltipTarget;
    return {
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
      className: this.tooltipClasses,
      formatter: (params) => {
        return Mustache.render(tooltipTarget.innerHTML, tooltipData[params[0].axisValue]);
      }
    };
  }

  get options() {
    const opts = buildOptions(this.datesValue, this.valuesValue);
    opts.tooltip = this.tooltip;
    return opts;
  }
}
